var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mstIcon",class:("mdi-" + _vm.type),style:(_vm.styled)})}
var staticRenderFns = []

export { render, staticRenderFns }